import { render } from "./queqiaohui.vue?vue&type=template&id=b2eec8f4&scoped=true"
import script from "./queqiaohui.vue?vue&type=script&lang=js"
export * from "./queqiaohui.vue?vue&type=script&lang=js"

import "./queqiaohui.vue?vue&type=style&index=0&id=b2eec8f4&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2eec8f4"]])

export default __exports__